const config = require("../config.js");
const UTILS = require("../libs/utils.js");
const weapons = require("./weapons.js");
module.exports.initialize = function (p16672) {
  var vA753 = [];
  if (p16672) {
    for (var vLN02435 = 0; vLN02435 < p16672.length; vLN02435++) {
      p16672[vLN02435].DAT = UTILS.parseJson(p16672[vLN02435].DAT);
      p16672[vLN02435].SV = p16672[vLN02435].PV || 0;
      p16672[vLN02435].REW = UTILS.parseJson(p16672[vLN02435].REW);
      vA753.push(p16672[vLN02435]);
    }
  }
  return vA753;
};
var vA754 = ["score", "k", "w", "gp", "d", "stk", "hs", "ls", "mk", "fk", "ast", "spry", "wb", "airk", "qs", "ns", "lns", "cc", "drk", "tk", "tmk", "fb", "cps", "rk", "cb", "bzk", "dmg", "sad", "cad", "bst", "find", "rcm", "twm", "atkm", "defm", "dny", "cnf", "eggs", "geggs", "amp", "wpb", "cvrt", "aik", "prks", "pump", "mirror", "mybx"];
var vA755 = ["kstk", "tower", "pkr", "island", "time"];
var vA756 = ["amc", "uwk", "rnd"];
var vO431 = {};
module.exports.checkChallenge = function (game, p16674, p16675, p16676, p16677, p16678, p16679, p16680) {
  if (p16676 == p16674.DAT.ky && p16674.PT != 1 && (p16674.DAT.mp == null || game && game.mapIndex == p16674.DAT.mp) && (p16674.DAT.mid == null || game && game.customMapData && game.customMapData.id == p16674.DAT.mid) && (p16674.DAT.md == null || game && game.modeIndex == p16674.DAT.md) && (p16674.DAT.wep == null || p16678.wep == p16674.DAT.wep) && (p16674.DAT.cls == null || p16679.classIndex == p16674.DAT.cls) && (p16674.DAT.stk == null || p16678.stk == p16674.DAT.stk) && (p16674.DAT.item == null || p16678.item == p16674.DAT.item) && (p16674.T != "ranked" || game && game.isComp)) {
    if (!p16679.challengeProg[p16675]) {
      p16679.challengeProg[p16675] = {
        progVal: p16674.PV || 0,
        startVal: p16674.SV || 0
      };
    }
    var v13477 = p16679.challengeProg[p16675].progVal;
    if (vA756.indexOf(p16676) >= 0) {
      p16679.challengeProg[p16675].progVal = p16677 > p16679.challengeProg[p16675].progVal ? p16677 : p16679.challengeProg[p16675].progVal;
    } else if (p16676 == "kstk") {
      var v13478 = p16674.DAT.wep == null && p16678.nonWep != null ? p16678.nonWep : p16677;
      p16679.challengeProg[p16675].progVal = v13478 > p16679.challengeProg[p16675].progVal ? v13478 : p16679.challengeProg[p16675].progVal;
    } else if (vA755.indexOf(p16676) == -1) {
      p16679.challengeProg[p16675].progVal += p16677;
    } else {
      p16679.challengeProg[p16675].progVal = p16677;
    }
    var v13479 = p16674.PT != 1 && v13477 < p16674.DAT.val && (p16674.DAT.lesser ? p16679.challengeProg[p16675].progVal && p16679.challengeProg[p16675].progVal <= p16674.DAT.val : p16679.challengeProg[p16675].progVal >= p16674.DAT.val);
    if (v13479) {
      game.players.challengeCompleted(p16679, p16675, p16674.REW);
    }
    if ((p16674.DAT.lesser ? v13477 > p16674.DAT.val : v13477 < p16674.DAT.val) && p16679.challengeProg[p16675].progVal <= p16674.DAT.val && v13477 != p16679.challengeProg[p16675].progVal) {
      if (vA755.indexOf(p16676) >= 0 && !v13479) {
        return;
      }
      if (vA756.indexOf(p16676) >= 0 && !v13479) {
        return;
      }
      p16680.push(p16674.CI, p16679.challengeProg[p16675].progVal);
    }
  }
};
module.exports.update = function (p16681, p16682, p16683, p16684, p16685) {
  if (p16685 && p16685.account && (!p16681 || p16681.isPubType()) && !(p16685.account.level < config.minChalLevel)) {
    var vA757 = [];
    p16684 = p16684 || vO431;
    var v13480;
    for (var vLN02436 = 0; vLN02436 < p16685.account.activeChallenges.length; vLN02436++) {
      v13480 = p16685.account.activeChallenges[vLN02436];
      module.exports.checkChallenge(p16681, v13480, vLN02436, p16682, p16683, p16684, p16685, vA757);
    }
    if (vA757.length) {
      p16685.send("uchp", vA757);
    }
  }
};
module.exports.updateMulti = function (p16686, p16687, p16688, p16689) {
  if (p16689 && p16689.account && (!p16686 || p16686.isPubType()) && !(p16689.account.level < config.minChalLevel)) {
    var vA758 = [];
    p16688 = p16688 || vO431;
    var v13481;
    for (var vLN02437 = 0; vLN02437 < p16689.account.activeChallenges.length; vLN02437++) {
      v13481 = p16689.account.activeChallenges[vLN02437];
      for (var vLN02438 = 0; vLN02438 < p16687.length; vLN02438 += 2) {
        module.exports.checkChallenge(p16686, v13481, vLN02437, p16687[vLN02438], p16687[vLN02438 + 1], p16688, p16689, vA758);
      }
    }
    if (vA758.length) {
      p16689.send("uchp", vA758);
    }
  }
};
module.exports.finalize = function (p16690, p16691, p16692, p16693, p16694) {
  if (p16690 && p16690.account && p16690.account.activeChallenges && p16690.challengeProg) {
    var v13482 = p16690.account.id;
    var vA759 = [];
    var vLN02439 = 0;
    for (var vLN02441 = 0; vLN02441 < p16690.account.activeChallenges.length; vLN02441++) {
      if (p16690.challengeProg[vLN02441]) {
        var v13486 = p16690.account.activeChallenges[vLN02441];
        if (v13486 && (!p16693 || v13486.DAT.nem)) {
          var v13487 = true;
          var v13489 = v13486.PT != 1 && (v13486.DAT.lesser ? p16690.challengeProg[vLN02441].progVal && p16690.challengeProg[vLN02441].progVal <= v13486.DAT.val : p16690.challengeProg[vLN02441].progVal >= v13486.DAT.val);
          if (v13486.PT == 1 || p16690.challengeProg[vLN02441].progVal == v13486.PV || v13486.DAT.sm && !v13489) {
            v13487 = false;
          }
          if (vA755.indexOf(v13486.DAT.ky) >= 0 && !v13489) {
            v13487 = false;
          }
          if (vA756.indexOf(v13486.DAT.ky) >= 0 && !v13489) {
            v13487 = false;
          }
          if (v13487) {
            if (v13489) {
              p16690.account.activeChallenges[vLN02441].PT = 1;
              if (!p16693) {
                p16690.send("chgC", vLN02441);
              }
              vLN02439 += v13486.REW.bpp || 0;
            }
            p16690.account.activeChallenges[vLN02441].PV = p16690.challengeProg[vLN02441].progVal;
            vA759.push(v13489 ? 1 : 0, v13486.CI, p16690.account.activeChallenges[vLN02441].PV);
          }
          if (v13486.DAT.sm && !v13487) {
            p16690.account.activeChallenges[vLN02441].PV = 0;
            p16690.account.activeChallenges[vLN02441].SV = 0;
          }
        }
      }
    }
    var v13486;
    for (var vLN02441 = 0; vLN02441 < p16690.account.activeChallenges.length; vLN02441++) {
      v13486 = p16690.account.activeChallenges[vLN02441];
      if (v13486 && v13486.DAT.ky == "chall" && (!p16693 || v13486.DAT.nem)) {
        if (!p16690.challengeProg[vLN02441]) {
          p16690.challengeProg[vLN02441] = {
            progVal: v13486.PV || 0,
            startVal: v13486.SV || 0
          };
        }
        var v13487 = true;
        var v13488 = p16690.account.activeChallenges.filter(p16695 => p16695.PT == 1 && p16695.T == v13486.T && (v13486.DAT.wep == null || p16695.DAT.wep == v13486.DAT.wep) && (v13486.DAT.cls == null || p16695.DAT.cls == v13486.DAT.cls) && (v13486.DAT.mp == null || p16695.DAT.mp == v13486.DAT.mp) && (v13486.DAT.mid == null || p16695.DAT.mid == v13486.DAT.mid) && (v13486.DAT.md == null || p16695.DAT.md == v13486.DAT.md) && (v13486.DAT.evt == null || p16695.DAT.evt == v13486.DAT.evt) && (v13486.DAT.seas == null || p16695.DAT.seas == v13486.DAT.seas));
        p16690.challengeProg[vLN02441].progVal = v13488.length;
        var v13489 = v13486.PT != 1 && p16690.challengeProg[vLN02441].progVal >= v13486.DAT.val;
        if (v13486.PT == 1 || p16690.challengeProg[vLN02441].progVal == v13486.PV || v13486.DAT.sm && !v13489) {
          v13487 = false;
        }
        if (v13487) {
          if (v13489) {
            p16690.account.activeChallenges[vLN02441].PT = 1;
            if (!p16693) {
              p16690.send("chgC", vLN02441);
            }
            vLN02439 += v13486.REW.bpp || 0;
          }
          p16690.account.activeChallenges[vLN02441].PV = p16690.challengeProg[vLN02441].progVal;
          vA759.push(v13489 ? 1 : 0, v13486.CI, p16690.account.activeChallenges[vLN02441].PV);
        }
        if (v13486.DAT.sm && !v13489) {
          p16690.account.activeChallenges[vLN02441].PV = 0;
          p16690.account.activeChallenges[vLN02441].SV = 0;
        }
      }
    }
    if (!p16693) {
      p16690.challengeProg.length = 0;
    }
    if (vA759.length) {
      try {
        p16690.tmpBPData.cbp = vLN02439;
        p16690.tmpBPData.bpp += vLN02439;
        p16690.tmpBPData.unbpp += vLN02439;
        p16690.tmpBPData.rbpp -= vLN02439;
        p16690.account.BP.bpp += p16690.tmpBPData.cbp;
        p16690.tmpBPData.re = p16694.getNextReward(p16690.tmpBPData.bpp, p16690.account.BP.tier);
      } catch (e172) {
        console.log("CHALLENGES ERROR", e172);
      }
      p16691.call(175, [v13482, vA759.join(",")], function (p16696, p16697) {
        p16697 = p16697 && p16697[0] ? p16697[0][0] : null;
        if (p16697 && p16697.rsp != "Try later" && (p16697.rsp + "").includes("{")) {
          var vO432 = {
            kr: 0,
            jnk: 0,
            skins: [],
            bpp: 0
          };
          for (var v13490 = UTILS.parseJson("[" + p16697.rsp + "]"), vLN02442 = 0; vLN02442 < v13490.length; vLN02442++) {
            if (v13490[vLN02442].kr) {
              vO432.kr += v13490[vLN02442].kr;
            }
            if (v13490[vLN02442].jnk) {
              vO432.jnk += v13490[vLN02442].jnk;
            }
            if (v13490[vLN02442].sk) {
              vO432.skins.push(...(Array.isArray(v13490[vLN02442].sk) ? v13490[vLN02442].sk : [v13490[vLN02442].sk]));
            }
            if (v13490[vLN02442].bpp) {
              vO432.bpp += v13490[vLN02442].bpp;
            }
          }
          if (vO432.kr || vO432.jnk || vO432.skins.length || vO432.bpp) {
            var v13491 = p16694 && p16694.data ? p16694.data.id : 0;
            p16691.call(176, ["chall", v13482, vO432.kr, vO432.jnk, vO432.skins.join(","), v13491, vO432.bpp], function (p16698, p16699) {
              p16699 = p16699 && p16699[0] && p16699[0][0] ? p16699[0][0] : null;
              if (p16690 && p16690.account && !p16693) {
                var v13492 = false;
                if (p16699 && p16699.fds != null && p16699.fds != null) {
                  v13492 = true;
                  p16690.account.funds = p16699.fds;
                }
                if (p16699 && p16699.jnk != null && p16699.jnk != null) {
                  v13492 = true;
                  p16690.account.junk = parseFloat(p16699.jnk);
                }
                var v13493 = p16699 && p16699.ski != null && p16699.ski != null ? p16699.ski.split(",") : [];
                if (v13493 && v13493.length) {
                  v13492 = true;
                  for (var vLN02443 = 0; vLN02443 < v13493.length; vLN02443++) {
                    v13493[vLN02443] = parseInt(v13493[vLN02443]);
                    p16690.account.addSkin(v13493[vLN02443]);
                  }
                }
                if (v13492) {
                  p16690.send("chlR", v13493, p16690.account.funds, p16690.account.junk, vO432.jnk, vO432.kr);
                }
              }
            });
          }
        }
      });
      if (!p16693) {
        p16690.send("chg", vA759);
      }
    }
  }
};
module.exports.updateNames = function (p16700, p16701) {
  if (p16700) {
    for (var vLN02444 = 0; vLN02444 < p16700.length; vLN02444++) {
      if (!p16700[vLN02444].N || !p16700[vLN02444].N.length) {
        p16700[vLN02444].N = p16701.t("chall.name." + p16700[vLN02444].DAT.ky, p16700[vLN02444].DAT.val, p16700[vLN02444].T == "daily" && p16700[vLN02444].DAT.wep != null ? "with " + weapons[p16700[vLN02444].DAT.wep].name : "");
      }
    }
  }
  return p16700;
};